// frontend/src/components/DownloadProgressDonut/DownloadProgressDonut.jsx

import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const DownloadProgressDonut = ({ 
    progress, 
    size = 60, 
    fontSize = '0.75rem', 
    color = 'inherit',
    thickness = 4 // Added default thickness
}) => {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            {/* Background Circle (faded track) */}
            <CircularProgress
                variant="determinate"
                value={100}
                size={size}
                thickness={thickness}
                sx={{ 
                    color: color, 
                    opacity: 0.3, 
                    position: 'absolute', 
                    left: 0 
                }}
            />
            {/* Foreground Progress Circle */}
            <CircularProgress 
                variant="determinate" 
                value={progress} 
                size={size} 
                thickness={thickness}
                sx={{ color: color }} 
            />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography 
                    variant="caption" 
                    component="div" 
                    sx={{ 
                        color: color, 
                        fontSize: fontSize, 
                        fontWeight: 'bold',
                        lineHeight: 1 // Tighten line height to center better
                    }}
                >
                    {Math.round(progress)}%
                </Typography>
            </Box>
        </Box>
    );
};

export default DownloadProgressDonut;